
import { defineComponent } from 'vue';

import { galleryContentComposition } from '../services';
import CovidGalleryContentNoData from './covid-gallery-content-no-data.vue';
import CovidGalleryContentGrid from './covid-gallery-content-grid.vue';

/**
 * Vue components define
 */
export default defineComponent({
	components: {
		CovidGalleryContentNoData,
		CovidGalleryContentGrid,
	},
	setup() {
		return { ...galleryContentComposition() };
	},
})
